// extracted by mini-css-extract-plugin
export default {"applicationNumber":"ClientMessageFieldsAndAttachments_applicationNumber__prjrD"};